(function() {
    'use strict';

a3_cabin_reports.directive('wifiVouchers',wifiVouchers);
 
   /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name wifiVouchers
   * @restrict EA
   * @description
   *   Implementation of wifiVouchers
   *
   *   Initialize the wifi vouchers panel needs to have flight in scope
   * @example
   *   Usage:
   *   <wifi-vouchers></wifi-vouchers>
   * @ngInject
   */    
function wifiVouchers(WifiVouchersFactory, WifiAvailabilityFactory, $timeout ) {
    
    /**
     * Initialize wifiVouchers
     * @memberof wifiVouchers
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link (scope, element, attrs) {   

		var wifiAvailability = WifiAvailabilityFactory.getRegistrationsFromStorage();
        if(wifiAvailability){
            scope.supportsWifi = wifiAvailability.registrations.includes(scope.flight.AcTailNo);
        }else{
            scope.supportsWifi = false;
        }

        scope.retrieve = retrieve;
        // scope.createVoucher = createVoucher;
        scope.showPanel = '';
        scope.submitMessage = '';
        scope.pnrNo = null;
        scope.wifiVouchersCodes = [];
        scope.textAndSurfCodes = [];
        scope.streamCodes = [];
        scope.isFlightView = true;

        function retrieve(pnrNo) {
            if(scope.isOffline){
                scope.showPanel = "offline";
            }
            else{
                scope.showPanel = "loading";                
               
                var RequestWifiVouchers = {
                    PNR : pnrNo,
                    FlightId: scope.flight.FlightId,
                    Flight: scope.paxInfo.STDLocal
                };
                WifiVouchersFactory.retrieveWifiVouchers(RequestWifiVouchers)
                    .then(res => handleSubmitResponse(res));            
            }
        }

    	function handleSubmitResponse(res) {
			if (res.success) {
                scope.notRetrieved = false;
                scope.textAndSurfCodes = [];
                scope.streamCodes = [];
				manageResponseMessage("success", res.message);
				scope.wifiVouchersCodes = res.data;

				scope.wifiVouchersCodes.forEach(function (code) {
                    if(code.Type == 'Text & Surf') {
                        scope.textAndSurfCodes.push(code.VoucherCode);
                    }
                });

				scope.wifiVouchersCodes.forEach(function (code) {
                    if(code.Type == 'Stream') {
                        scope.streamCodes.push(code.VoucherCode);
                    }
                });
			}
			else {
				manageResponseMessage("failure", res.message);
			}
		}

         /**
             * Manage message alerts
             * @param {string} panelToShow 
             * @param {string} message 
             */
          function manageResponseMessage(panelToShow, message) {
            scope.submitMessage = message;
            scope.showPanel = panelToShow;
        }

    }
    return {
			restrict: 'EA',
			terminal: true,
            templateUrl: 'views/WifiVouchers/wifiVouchers.tpl.html',
			scope : false,
            link: link 
    }
}

})();